import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RadioButtonModule } from 'primeng/radiobutton';

export type RadioBoxValue = 'all' | 'yes' | 'no' | null;

@Component({
  selector: 'app-radio-box',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, RadioButtonModule],
  templateUrl: './radio-box.component.html',
  styleUrls: ['./radio-box.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioBoxComponent),
      multi: true
    }
  ]
})
export class RadioBoxComponent implements ControlValueAccessor {
  @Input() label?: string = '';
  @Input() disabled: boolean = false;
  @Input() name: string = `radio-group-${Math.random().toString(36).substr(2, 9)}`;
  @Input() direction: 'horizontal' | 'vertical' = 'horizontal';

  // Custom labels for each option
  @Input() allLabel: string = 'All';
  @Input() yesLabel: string = 'Yes';
  @Input() noLabel: string = 'No';

  // Show/hide options
  @Input() showAll: boolean = true;
  @Input() showYes: boolean = true;
  @Input() showNo: boolean = true;

  @Output() onChange = new EventEmitter<RadioBoxValue>();

  value: RadioBoxValue = null;

  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};

  writeValue(value: any): void {
    this.value = value || null;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onValueChange(newValue: RadioBoxValue): void {
    this.value = newValue;
    this.onChangeCallback(this.value);
    this.onChange.emit(this.value);
    this.onTouchedCallback();
  }
}
